import React , {useEffect} from 'react'
import {Route, Routes, useLocation} from 'react-router-dom';
import Header from '../components/Header/Main'
import Footer from '../components/Footer/Main'
import Hometwo from '../components/Hometwo/Main'
import About from '../components/About/Main'
import Project from '../components/Pages/Projects/Main'
import Projectdeatils from '../components/Pages/Projectsdetail/Main'
import Pricing from '../components/Pages/Pricing/Main'
import Team from '../components/Pages/Team/Main'
import Faq from '../components/Pages/Faq/Main'
import Shop from '../components/Pages/Shop/Main'
import Shopdeatils from '../components/Pages/Shopdetails/Main'
import Servise from '../components/Servise/Main'
import Servisedeatils from '../components/Servise-deatils/Main'
import Blog from '../components/Blog/Main'
import Blogdeatils from '../components/Blog-deatils/Main'
import Contact from '../components/Contact/Main'
import Teamdeatils from '../components/Teemdeatils/Main'
import Home from '../components/Home/Main'
import HomeOriginal from '../components/HomeOriginal/Main'
import CustomerInfo from '../components/CustomerInfo/Main'
import Hello from '../components/Hello/Main'
import SupplierDashboard from '../components/SupplierDashboard/Main'
import Login from '../components/Auth/Login'
import Register from '../components/Auth/Register'
import AdminLogin from '../components/Admin/Login'
import AdminDashboard from '../components/Admin/Dashboard'


function Index() {

  const location = useLocation();
  const path = location.pathname
  useEffect(() => {
    window.scroll(0, 0)
}, [path]);

  // Check if current path is dashboard or auth pages (no header/footer)
  const isDashboardPage = path === '/supplier-dashboard' || path === '/admin-dashboard';
  const isAuthPage = path === '/supplier-login' || path === '/supplier-register' || path === '/admin-login';

  return (
    <>
        {!isDashboardPage && !isAuthPage && <Header/>}
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/home-original" element={<HomeOriginal/>} />
          <Route path="/customer-info" element={<CustomerInfo/>} />
          <Route path="/hometwo" element={<Hometwo/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/project" element={<Project/>} />
          <Route path="/projectsdetail" element={<Projectdeatils/>} />
          <Route path="/pricing" element={<Pricing/>} />
          <Route path="/team" element={<Team/>} />
          <Route path="/faq" element={<Faq/>} />
          <Route path="/shop" element={<Shop/>} />
          <Route path="/shopdeatils" element={<Shopdeatils/>} />
          <Route path="/Service" element={<Servise/>} />
          <Route path="/Servicedeatils" element={<Servisedeatils/>} />
          <Route path="/blog" element={<Blog/>} />
          <Route path="/blogdetails" element={<Blogdeatils/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/teamdeatils" element={<Teamdeatils/>} />
          <Route path="/main" element={<Hello/>} />
          <Route path="/supplier-login" element={<Login/>} />
          <Route path="/supplier-register" element={<Register/>} />
          <Route path="/supplier-dashboard" element={<SupplierDashboard/>} />
          <Route path="/admin-login" element={<AdminLogin/>} />
          <Route path="/admin-dashboard" element={<AdminDashboard/>} />
        </Routes>
        {!isDashboardPage && !isAuthPage && <Footer/>}
    </>
  )
}

export default Index